import { render } from "./TemplateBookBookingResult.vue?vue&type=template&id=096e0780&scoped=true"
import script from "./TemplateBookBookingResult.vue?vue&type=script&lang=js"
export * from "./TemplateBookBookingResult.vue?vue&type=script&lang=js"

import "./TemplateBookBookingResult.vue?vue&type=style&index=0&id=096e0780&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-096e0780"

export default script